import React , { useState  } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {ListGroup, ListGroupItem, Input } from 'reactstrap';
import { set_selected_fav_prompt_data, set_selected_fav_prompt_id_element } from '../../slices/dashboard/reducer';

const Dashboard_Favprompt_Item = ({ data }) => {
const dispatch = useDispatch()
const { selected_fav_prompt_id_element} = useSelector((state)=>state.Dashboard)
 

const handleSelect = (e)=>{
  if(e.target.checked){

    dispatch(set_selected_fav_prompt_id_element(data.BotFavoritePromptId))
    dispatch(set_selected_fav_prompt_data(data))
  }
  else{
    dispatch(set_selected_fav_prompt_id_element(null))
    dispatch(set_selected_fav_prompt_data(null))
  }
}

  return (
    <>

            <ListGroupItem><Input onChange={handleSelect} checked={data.BotFavoritePromptId == selected_fav_prompt_id_element } className="form-check-input" type="checkbox" id="formCheck1" /> {data.Description}  Visualization Type: {data.Visualization.toUpperCase().replace('_',' ')}</ListGroupItem>
  
    </>
  )
}

export default Dashboard_Favprompt_Item